import { render } from "./PokemonPage.vue?vue&type=template&id=6702f5eb"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\perez\\Proyectos\\Vue\\04-pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__